import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/AuthContext';
import {
  UserCircle, Bell, Lock, Shield, HelpCircle, ChevronRight, LogOut, Database
} from 'lucide-react';

/**
 * SettingsPage — Account settings for all user types.
 */
const SettingsPage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/welcome');
  };

  const settingsItems = [
    { icon: UserCircle, label: 'Profile', desc: 'Manage your personal information', path: '/profile' },
    { icon: Bell, label: 'Notifications', desc: 'Configure notification preferences', path: '/notification-preferences' },
    { icon: Shield, label: 'Security', desc: 'Password and account security', path: '/profile' },
    ...(user?.role === 'USER' ? [{ icon: Database, label: 'My Data & Privacy', desc: 'Export data, manage consent, request deletion', path: '/my-data' }] : []),
    { icon: HelpCircle, label: 'Help & Support', desc: 'Get help or contact support', path: '/help' },
  ];

  return (
    <div className="space-y-6 py-6">
      <div>
        <h2 className="font-headline text-2xl font-extrabold text-slate-900 tracking-tight">Settings</h2>
        <p className="text-slate-500 text-sm mt-1">Manage your account preferences</p>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-outline-variant/10 overflow-hidden">
        {settingsItems.map((item, i) => {
          const Icon = item.icon;
          return (
            <button
              key={item.label}
              onClick={() => item.path && navigate(item.path)}
              disabled={!item.path}
              className={`w-full flex items-center justify-between p-5 hover:bg-slate-50 transition-all text-left ${
                i > 0 ? 'border-t border-slate-100' : ''
              } ${!item.path ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary">
                  <Icon className="w-5 h-5" />
                </div>
                <div>
                  <p className="text-sm font-bold text-slate-900">{item.label}</p>
                  <p className="text-xs text-slate-500">{item.desc}</p>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-slate-500" />
            </button>
          );
        })}
      </div>

      {/* Logout */}
      <button
        onClick={handleLogout}
        className="w-full flex items-center justify-center gap-3 p-4 bg-red-50 text-red-600 rounded-2xl font-bold hover:bg-red-100 transition-all"
      >
        <LogOut className="w-5 h-5" />
        Log Out
      </button>

      <p className="text-center text-xs text-slate-500">
        SymptoConnect v1.0 · Logged in as {user?.email}
      </p>
    </div>
  );
};

export default SettingsPage;
